import { route } from '@aurelia/router';
import { PresentForm } from './present-form';
import { PresentEvent } from './present-event';

@route({
  routes: [
    { path: ['', 'view'], component: PresentForm, title: 'present-form' },
    { path: ':code', component: PresentEvent, title: 'present-event' },
  ],
})
export class PresentSection {
}
